/**
 * ワークフロー依頼(右側表示)内のタブと対応している
 */
export enum ReceptionReferenceKinds {
  Document = 1,
  Workflow = 2,
  Detail = 3,
  RequestSheet = 4,
  DetailHistory = 5,
  ManagerHistory = 6,
}
